import React from 'react';
import { Row } from 'antd';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { BodySubtitle, SuggestionCard } from './index';

@injectIntl
@inject('onboardingStore')
@inject('routingStore')
@observer
class ItemsImportedBody extends React.Component {
  render() {
    const { intl, onboardingStore, routingStore } = this.props;
    return (
      <div>
        <BodySubtitle>
          <FormattedMessage id="onboarding.advanced.screen8.suggestions1" />
          <br />
          <FormattedMessage id="onboarding.advanced.screen8.suggestions2" />
          <Row style={{ display: 'flex', marginTop: '40px', justifyContent: 'space-evenly' }}>
            <SuggestionCard
              type="list-items"
              height={36}
              description={intl.formatMessage({ id: 'onboarding.advanced.screen8.howListItems' })}
              bodywidth={76}
              onClick={() => {
                onboardingStore.saveWizardState();
                onboardingStore.setWizardStep(onboardingStore.wizardStepIndex + 1);
                onboardingStore.enableTutorial();
              }}
            />
            <SuggestionCard
              type="education-center"
              height={27}
              description={intl.formatMessage({
                id: 'onboarding.advanced.screen8.checkEducationCenter',
              })}
              onClick={() => {
                onboardingStore.saveWizardState();
                onboardingStore.setWizardStep(onboardingStore.wizardStepIndex + 1);
                routingStore.browserHistory.push('/learning');
              }}
            />
          </Row>
        </BodySubtitle>
      </div>
    );
  }
}

ItemsImportedBody.propTypes = {
  intl: PropTypes.object,
  onboardingStore: PropTypes.object,
};

export default ItemsImportedBody;
